'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcACN
* @element ANY
* @description
* # tcACN
* Adds placeholder for an ACN
*/
angular.module('tcApp')
.directive('tcAcn', function() {
	
	return {
			templateUrl: 'template/acn/acn.html',
			restrict: 'E',
			scope: {
				data: '=?',
				options: '=?',
			},
			controller: 'ActiveClinicalNotesCtrl',
		};
});
